import { apiFetch } from '../api/client';
import { analyticsAllowed, ANALYTICS_CHOICE_EVENT } from './measurementContext';

const recent = new Map();
const pending = new Set();
const names = new Set(['screen_view', 'paywall_view', 'checkout_intent', 'app_foreground']);
const screens = new Set(['chat', 'diary', 'calendar', 'tracker', 'analytics', 'settings', 'billing', 'code']);
export function cancelMeasurementEvents() {
  for (const controller of pending) controller.abort();
  pending.clear(); recent.clear();
}
if (typeof window !== 'undefined') {
  window.addEventListener(ANALYTICS_CHOICE_EVENT, () => { if (!analyticsAllowed()) cancelMeasurementEvents(); });
  window.addEventListener('noesa:auth-cleared', cancelMeasurementEvents);
  window.addEventListener('storage', (event) => {
    if (!event.key || event.key === 'ai_diary_auth' || !analyticsAllowed()) cancelMeasurementEvents();
  });
}
export function recordClientEvent(name, screen) {
  if (!analyticsAllowed() || !names.has(name) || (screen && !screens.has(screen))) return;
  try {
    const auth = JSON.parse(localStorage.getItem('ai_diary_auth') || '{}');
    if (!auth?.user) return;
    const key = `${auth.user.username || ''}:${name}:${screen || ''}`;
    if (Date.now() - (recent.get(key) || 0) < 1500) return;
    if (recent.size > 100) recent.clear();
    recent.set(key, Date.now());
    const id = crypto.randomUUID();
    const controller = new AbortController();
    pending.add(controller);
    const timeout = setTimeout(() => controller.abort(), 1500);
    void apiFetch('/measurement/events', {
      method: 'POST', body: { name, screen, event_id: id }, signal: controller.signal, suppressAuthError: true,
    }).catch(() => {}).finally(() => { clearTimeout(timeout); pending.delete(controller); });
  } catch { /* Optional telemetry cannot block navigation. No offline replay across accounts. */ }
}
